export function decodeJwt(token: string | null | undefined): Record<string, unknown> | null {
  if (!token) return null
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null

    const decoded = atob(parts[1] || '')
    return JSON.parse(decoded) as Record<string, unknown>
  } catch {
    return null
  }
}

export function getTenantIdFromToken(token: string | null): string | null {
  if (!token) return null
  const payload = decodeJwt(token)
  return (payload?.tenantId as string) || null
}

export function getUserIdFromToken(token: string | null): string | null {
  if (!token) return null
  const payload = decodeJwt(token)
  return (payload?.sub as string) || null
}
